// src/pages/ChatPage.jsx
import React, { useState, useRef, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { FaPaperPlane } from 'react-icons/fa';
import { API_BASE_URL } from '../config/config';
import './ChatPage.css';

export default function ChatPage() {
  const [msgs, setMsgs] = useState([]);
  const [inpt, setInpt] = useState('');
  const [loading, setLoading] = useState(false);
  const [rid, setRid] = useState(null);
  const ref = useRef(null);

  const send = async () => {
    if (!inpt.trim()) return;
    setMsgs(m => [...m, { role: 'user', content: inpt }]);
    const userMessage = inpt;
    setInpt('');
    setLoading(true);

    try {
      const res = await fetch(`${API_BASE_URL}/chat`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ message: userMessage, prevId: rid })
      });

      const data = await res.json();
      setMsgs(m => [...m, {
        role: 'assistant',
        content: data.content,
        citations: data.citations || []
      }]);

      if (data.responseId) setRid(data.responseId);
    } catch (error) {
      console.error(error);
      setMsgs(m => [...m, { role: 'assistant', content: 'Error al conectar con el servidor.' }]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (ref.current) ref.current.scrollTop = ref.current.scrollHeight;
  }, [msgs]);

  return (
    <div className="chat-page">
      <h1 className="chat-title">Asistente Virtual</h1>
      <div className="chat-container">
        <div className="chat-messages" ref={ref}>
          {msgs.map((m, i) => (
            <div key={i} className={`chat-message ${m.role}`}>
              {m.role === 'assistant'
                ? <ReactMarkdown remarkPlugins={[remarkGfm]}>
                    {insertLinks(m.content, m.citations)}
                  </ReactMarkdown>
                : m.content}
            </div>
          ))}
          {loading && <div className="chat-message assistant">⏳ Generando...</div>}
        </div>
        <div className="chat-input">
          <input
            value={inpt}
            onChange={e => setInpt(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && send()}
            placeholder="Escribe tu pregunta..."
          />
          <button onClick={send}><FaPaperPlane /></button>
        </div>
      </div>
    </div>
  );
}

function insertLinks(text, citations = []) {
  if (!citations.length) return text;
  return text.replace(/\[(\d+)]/g, (_, n) => {
    const c = citations[n - 1];
    return c && c.url ? `[${n}](${c.url})` : `[${n}]`;
  });
}
